import React, { useEffect } from 'react'
import { trackPromise, usePromiseTracker } from 'react-promise-tracker';

//const FetchDummyTest = (openAlert) => {
//    const createArticle = 'dummy/test'
//    fetch(createArticle, {
//        method: "GET",
//        //mode: "no-cors",
//        headers: {
//            'Accept': '*',
//            'Content-Type': 'application/json; charset=utf-8',
//        },
//    }).then(function (response) {
//        throw new Error(response.statusText)
//        return response.json()
//    }).catch(function (err) {
//        console.log('Fetch problem: ' + err.message)
//        openAlert()
//    });
//}

///ArticleTypeView
const FetchCreateArticle = async (articleToCreate, handleCloseModal, openAlert) => {
    console.log("FETCH CREATE ARTICLE")
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let ownerSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId
    const createArticle = 'faex/articleTypes/createArticleTypes/{' + sessionSysId + '}/{' + ownerSysId + '}'
    try {
        let response = await fetch(createArticle, {
            method: "POST",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(articleToCreate),
        })
        if (response.ok) {
            handleCloseModal()
            return await response.json()

        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }


    //fetch(createArticle, {
    //    method: "POST",
    //    //mode: "no-cors",
    //    headers: {
    //        'Accept': '*',
    //        'Content-Type': 'application/json; charset=utf-8',
    //    },
    //    body: JSON.stringify(articleToCreate),
    //}).then(function (response) {
    //    console.log("Create Article Response")
    //    console.log(response)
    //    if (response.ok) {
    //        handleCloseModal()
    //        return response.json()
    //    }
    //    else {
    //        throw new Error(response.statusText)
    //    }
    //}).catch(function (err) {
    //    console.log('Fetch problem: ' + err.message)
    //    openAlert()
    //});
}

const FetchUpdateArticle = async (articleToUpdate, handleCloseArticle, openAlert) => {

    const updateArticle = 'faex/articleTypes/updateArticleTypes'
    try {
        let response = await fetch(updateArticle, {
            method: "PUT",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(articleToUpdate),
        })
        if (response.ok) {
            handleCloseArticle()
            return await response.json()
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}

const FetchArticleTypesTracked = async (setArticleData, openAlert, setArticleDataToReady) => {
    let ownerSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    const getArticleTypes = 'faex/articleTypes/getArticleTypes/{' + sessionSysId + '}/{' + ownerSysId + '}'
    console.log(getArticleTypes)
    
    try {
        let response = await fetch(getArticleTypes)
        if (response.ok) {
            let json = await response.json()
            console.log("ReadArticleTypes")
            console.log(JSON.parse(json))
            await setArticleData(JSON.parse(json))
            setArticleDataToReady(true)
        } else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}

const FetchArticleTypes = (setArticleData, openAlert, setArticleDataToReady) => {
    trackPromise(FetchArticleTypesTracked(setArticleData, openAlert, setArticleDataToReady))
}

//const FetchArticleTypeImagesDummy = (articlSysId, addingImages, openAlert) => {
//    const randomNumber = Math.floor(Math.random() * images.length);
//    addingImages(articlSysId, images[randomNumber])
//}

const FetchArticleTypeImages = (articleSysIds, addingImages, openAlert, area) => {
    trackPromise(FetchArticleTypeImagesTracked(articleSysIds, addingImages, openAlert), area)
}

const FetchArticleTypeImagesTracked = async (articleSysIds, addingImages, openAlert) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    const getArticleTypeImage = 'faex/articleTypes/getArticleTypeImages/{' + sessionSysId + '}'
    try {
        let response = await fetch(getArticleTypeImage, {
            method: "PUT",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(articleSysIds),
        })
        if (response.ok) {
            let json = await response.json()
            console.log("Picture JSON")
            console.log(articleSysIds)
            console.log(json)
            addingImages(JSON.parse(json))
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}

///DeliveryOrder & Stock
const FetchTransactionInfosTracked = async (setArticles, setSizeCats, openAlert, setArticleDataToReady, setArticlesCallback = () => { } ) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let ownerSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    let isFaex = JSON.parse(sessionStorage.getItem("loginInformation")).StorageType === "FAEX"
    const getTransationInfos = 'faex/transactions/getInfosForTransaction/{' + sessionSysId + '}/{' + ownerSysId + '}/{' + storageSysId + '}/{' + isFaex + '}'

    try {
        let response = await fetch(getTransationInfos)
        if (response.ok) {
            let json = await response.json()
            await setArticles(JSON.parse(json), setArticlesCallback)
            await setSizeCats([...new Set(JSON.parse(json).map(x => x.SizeCat))].sort())
            console.log("FetchTransactionInfos ", setArticlesCallback)
            setArticlesCallback()
            console.log(JSON.parse(json))
            setArticleDataToReady(true)
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}
const FetchTransactionInfos = (setArticles, setSizeCats, openAlert, setArticleDataToReady, setArticlesCallback = () => { }, area) => {
    trackPromise(FetchTransactionInfosTracked(setArticles, setSizeCats, openAlert, setArticleDataToReady, setArticlesCallback), area)
}

const FetchCreateTransaction = async (transactionToCreate, handleClose, openAlert, reloadParent = null, resetOrderEntries = null, setIsCreating) => {
    console.log("Login Information:")
    console.log(sessionStorage.getItem("loginInformation"))
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    const createTransaction = 'faex/transactions/createTransaction/{' + sessionSysId + '}/{' + storageSysId + '}'
    setIsCreating(true)
    try {
        let response = await fetch(createTransaction, {
            method: "POST",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(transactionToCreate),
        })
        if (response.ok) {
            handleClose()
            if (reloadParent !== null) reloadParent()
            if (resetOrderEntries !== null) resetOrderEntries()
            setIsCreating(false)
            return await response.json()
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        //handleClose()
        openAlert()
        setIsCreating(false)
    }
}

const FetchCreateTransactionDraft = async (draftToSave, handleClose, openAlert, reloadParent = null, resetOrderEntries = null, setIsCreating) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    const createTransaction = 'faex/transactions/createTransactionDraft/{' + sessionSysId + '}/{' + storageSysId + '}'
    setIsCreating(true)
    try {
        let response = await fetch(createTransaction, {
            method: "POST",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(draftToSave),
        })
        if (response.ok) {
            handleClose()
            if (reloadParent !== null) reloadParent()
            if (resetOrderEntries !== null) resetOrderEntries()
            setIsCreating(false)
            return await response.json()
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
        setIsCreating(false)
    }
}

const FetchCreatePartialInventoryTransactionDraftTracked = async (draftToSave, handleClose, openAlert, reloadParent = null, resetOrderEntries = null, setIsCreating, signal) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    let mandatorSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId

    const createTransaction = 'faex/transactions/createPartialInventoryTransactionDraft/{' + sessionSysId + '}/{' + mandatorSysId + '}/{' + storageSysId + '}/'
    console.log("FetchCreatePartialInventoryTransactionDraft", createTransaction)
    setIsCreating(true)
    try {
        let response = await fetch(createTransaction, {
            method: "POST",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(draftToSave),
            signal: signal
        })
        if (response.ok) {
            handleClose()
            if (reloadParent !== null) reloadParent()
            if (resetOrderEntries !== null) resetOrderEntries()
            setIsCreating(false)
            return await response.json()
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
        setIsCreating(false)
    }
}

const FetchCreatePartialInventoryTransactionDraft = (draftToSave, handleClose, openAlert, reloadParent = null, resetOrderEntries = null, setIsCreating, signal, area) => {
    trackPromise(FetchCreatePartialInventoryTransactionDraftTracked(draftToSave, handleClose, openAlert, reloadParent, resetOrderEntries, setIsCreating, signal), area)
}

const FetchCreateStartFullInventoryTransactionTracked = async (transaction, changeParent, openAlert, setIsCreating, signal) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    let mandatorSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId

    const createTransaction = 'faex/transactions/createFullInventoryTransactionDraft/{' + sessionSysId + '}/{' + mandatorSysId + '}/{' + storageSysId + '}/'
    setIsCreating(true)
    try {
        let response = await fetch(createTransaction, {
            method: "POST",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(transaction),
            signal: signal
        })
        if (response.ok) {
            changeParent()
            setIsCreating(false)
            return await response.json()
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
        setIsCreating(false)
    }
}

const FetchCreateStartFullInventoryTransaction = async (transaction, changeParent, openAlert, setIsCreating, signal, area) => {
    await trackPromise(FetchCreateStartFullInventoryTransactionTracked(transaction, changeParent, openAlert, setIsCreating, signal), area)
}

const FetchCreateInventoryTransactionTracked = async (draftSysId, handleClose, openAlert, reloadParent = null, resetOrderEntries = null, setIsCreating, signal) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    let mandatorSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId

    const createTransaction = 'faex/transactions/createInventoryTransaction/{' + sessionSysId + '}/{' + mandatorSysId + '}/{' + storageSysId + '}/{' + draftSysId + '}'
    setIsCreating(true)
    try {
        let response = await fetch(createTransaction, {
            method: "PUT",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            signal: signal
        })
        if (response.ok) {
            let message = JSON.parse(response.json())
            if(message == "")
                handleClose()
            else
                throw new Error(message)
            if (reloadParent !== null) reloadParent()
            if (resetOrderEntries !== null) resetOrderEntries()
            setIsCreating(false)
            return await response.json()
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
        setIsCreating(false)
    }
}


const FetchCreateInventoryTransaction = async(draftSysId, handleClose, openAlert, reloadParent = null, resetOrderEntries = null, setIsCreating, signal, area) => {
    await trackPromise(FetchCreateInventoryTransactionTracked(draftSysId, handleClose, openAlert, reloadParent, resetOrderEntries, setIsCreating, signal), area)
}

const FetchStartedFullInventoryTransactionTracked = async (setStartedFullInventoryTransaction, openAlert, setArticleDataToReady, signal) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    let mandatorSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId

    console.log("showInventoryTransactionMask Started Full Inventory Transactions")

    const readTransaction = 'faex/transactions/readFullInventoryTransactionDraft/{' + sessionSysId + '}/{' + mandatorSysId + '}/{' + storageSysId + '}/'

    try {
        let response = await fetch(readTransaction, { signal })
        if (response.ok) {
            let json = await response.json()
            console.log("showInventoryTransactionMask Started Full Inventory Transactions", json, JSON.parse(json))
            console.log(json)
            await setStartedFullInventoryTransaction(JSON.parse(json))
            setArticleDataToReady(true)
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}


const FetchStartedFullInventoryTransaction = async (setStartedFullInventoryTransaction, openAlert, setArticleDataToReady, signal, area) => {
    await trackPromise(FetchStartedFullInventoryTransactionTracked(setStartedFullInventoryTransaction, openAlert, setArticleDataToReady, signal), area)
}

const FetchUpdateTransactionDraft = async (draftToUpdate, draftSysId, handleClose, openAlert, reloadParent = null, resetOrderEntries = null, setIsCreating) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    const createTransaction = 'faex/transactions/updateTransactionDraft/{' + sessionSysId + '}/{' + storageSysId + '}/{' + draftSysId + '}'
    setIsCreating(true)
    try {
        let response = await fetch(createTransaction, {
            method: "PUT",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(draftToUpdate),
        })
        if (response.ok) {
            handleClose()
            if (reloadParent !== null) {
                console.log("RELOAD")
                console.log(reloadParent)
                reloadParent()
            }
            if (resetOrderEntries !== null) resetOrderEntries()
            setIsCreating(false)
            return await response.json()
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
        setIsCreating(false)
    }
}

const FetchDeleteTransactionDraft = (draftToDelete, openAlert, reload, area) => {
    trackPromise(FetchDeleteTransactionDraftTracked(draftToDelete, openAlert, reload), area)
}

const FetchDeleteTransactionDraftTracked = async (draftToDelete, openAlert, reload) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    const deleteTransaction = 'faex/transactions/deleteTransactionDraft/{' + sessionSysId + '}/{' + storageSysId + '}/{' + draftToDelete + '}'
    try {
        let response = await fetch(deleteTransaction, {
            method: "DELETE",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
        })
        if (response.ok) {
            reload()
            return await response.json()
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}

const FetchDeleteSaleTransaction = async (saletransactionToDelete, openAlert, reload) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    console.log("FetchDeleteSaleTransaction", saletransactionToDelete)
    const deleteTransaction = 'faex/transactions/deleteSaleTransaction/{' + sessionSysId + '}/{' + storageSysId + '}/{' + saletransactionToDelete + '}'
    try {
        let response = await fetch(deleteTransaction, {
            method: "DELETE",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
        })
        if (response.ok) {
            reload()
            return await response.json()
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}

///Transactions
const FetchReadIncomingTransactionsTracked = async (setIncomingTransactions, openAlert, setArticleDataToReady, signal, confirmed = false, newArrivals = false) => {
    console.log("FetchReadIncomingTransactionsTracked ")
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let ownerSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    const readTransactions = 'faex/transactions/getIncomingTransactions/{' + sessionSysId + '}/{' + ownerSysId + '}/{' + storageSysId + '}/{' + confirmed + '}/{' + newArrivals + '}'
    try {
        let response = await fetch(readTransactions, { signal })
        //console.log("Incoming Transactions Response")
        //console.log(response)
        if (response.ok) {
            let json = await response.json()
            console.log("Incoming Transactions1", json)
            console.log(json)
            await setIncomingTransactions(JSON.parse(json))
            setArticleDataToReady(true)
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}
const FetchReadIncomingTransactions = (setIncomingTransactions, openAlert, setArticleDataToReady, signal, area, confirmed = false, newArrivals = false) => {
    console.log("FetchReadIncomingTransactions signal ", signal, area)
    trackPromise(FetchReadIncomingTransactionsTracked(setIncomingTransactions, openAlert, setArticleDataToReady, signal, confirmed, newArrivals), area,)
}

const FetchReadOutgoingTransactionsTracked = async (setOutgoingTransactions, openAlert, setArticleDataToReady, signal, confirmed = false, correctionToNewArrival = false) => {
    console.log("FetchReadOutgoingTransactionsTracked ")
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let ownerSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    const readTransactions = 'faex/transactions/getOutgoingTransactions/{' + sessionSysId + '}/{' + ownerSysId + '}/{' + storageSysId + '}/{' + confirmed + '}/{' + correctionToNewArrival + '}'
    try {
        let response = await fetch(readTransactions, { signal })
        //console.log("Incoming Transactions Response")
        //console.log(response)
        if (response.ok) {
            let json = await response.json()
            await setOutgoingTransactions(JSON.parse(json))
            setArticleDataToReady(true)
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        if (err && err.name !== "AbortError") openAlert()
    }
}
const FetchReadOutgoingTransactions = (setOutgoingTransactions, openAlert, setArticleDataToReady, signal, area, confirmed = false, correctionToNewArrival = false) => {
    trackPromise(FetchReadOutgoingTransactionsTracked(setOutgoingTransactions, openAlert, setArticleDataToReady, signal, confirmed, correctionToNewArrival), area)
}

const FetchApproveCorrection = (stateChangeModel, handleCloseConfirmationModal, reload, openAlert, area) => {
    FetchApproveCorrectionTracked(stateChangeModel, handleCloseConfirmationModal, reload, openAlert, area)
}


const FetchApproveCorrectionTracked = async (stateChangeModel, handleCloseConfirmationModal, reload, openAlert) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    const approveCorrection = 'faex/transactions/approveCorrection/{' + sessionSysId + '}'
    try {
        let response = await fetch(approveCorrection, {
            method: "PUT",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(stateChangeModel),
        })
        if (response.ok) {
            handleCloseConfirmationModal()
            reload()
            return await response.json();
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}

///Inventory
const FetchInventoryTracked = async (setFetchStock, openAlert, setArticleDataToReady, signal) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let ownerSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    let isFaex = JSON.parse(sessionStorage.getItem("loginInformation")).StorageType == 'FAEX'
    const getInventoryRoute = 'faex/stock/getArticleStockItems/{' + sessionSysId + '}/{' + ownerSysId + '}/{' + storageSysId + '}/{' + isFaex + '}'
    try {
        let response = await fetch(getInventoryRoute, { signal })
        if (response.ok) {
            let json = await response.json()
            await setFetchStock(JSON.parse(json))
            setArticleDataToReady(true)
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        if (err && err.name !== "AbortError") openAlert()
    }
}
const FetchInventory = (setFetchStock, openAlert, setArticleDataToReady, signal, area) => {
    trackPromise(FetchInventoryTracked(setFetchStock, openAlert, setArticleDataToReady, signal), area)
}

const FetchLocalizedAnalysisTracked = async (articleTypeSysId, size, setLocalizedAnalysis, openAlert) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let ownerSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId
    const route = 'faex/stock/getLocalizedAnalysis/{' + sessionSysId + '}/{' + ownerSysId + '}/{' + articleTypeSysId + '}'
    try {
        let response = await fetch(route, {
            method: "POST",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(size),
        })
        if (response.ok) {
            let json = await response.json()
            await setLocalizedAnalysis(JSON.parse(json))
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}
const FetchLocalizedAnalysis = (articleTypeSysId, size, setLocalizedAnalysis, openAlert) => {
    trackPromise(FetchLocalizedAnalysisTracked(articleTypeSysId, size, setLocalizedAnalysis, openAlert))
}

///Login
const FetchLogin = (userHasAuthenticated, loginData, setError, area) => {
    const uri = 'login'
    trackPromise(
        fetch(uri, {
            method: "POST",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(loginData),
        }), area).then(function (response) {
            if (response.ok) {
                console.log("response is ok", response)
                console.log(response)
                return response.json()
            }
            else {
                throw new Error(response.statusText)
            }
        }).then(function (json) {
            console.log("response", json)
            setError(false)
            sessionStorage.setItem("isAuthenticated", "true")
            sessionStorage.setItem("loginInformation", json)
            sessionStorage.setItem("username", loginData.username)
            sessionStorage.setItem("serverVersion", JSON.parse(json).ServerVersion)
            userHasAuthenticated(true)
        }).catch(function (err) {
            console.log('Fetch Login problem: ' + err.message)
            console.log(err)
            setError(true)
        });
}
const FetchChangePassword = (passwordChangeData, setError) => {
    const uri = 'login/changePassword'
    console.log(uri)
    console.log(passwordChangeData)
    trackPromise(
        fetch(uri, {
            method: "POST",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(passwordChangeData),
        })).then(function (response) {
            if (response.ok) {
                console.log("response is ok")
                console.log(response)
                return response.json()
            }
            else {
                throw new Error(response.statusText)
            }
        }).then(function (json) {
            console.log("setting storage with:")
            console.log(json)
            setError(false)
        }).catch(function (err) {
            console.log('Fetch Login problem: ' + err.message)
            console.log(err)
            setError(true)
        });
}

///NewArticle
const FetchGenders = ( setGenders, openAlert ) => {
    const genderUri = 'faex/articleTypes/getGenders'
    console.log(genderUri)
    trackPromise(
        fetch(genderUri).then(function (response) {
            if (response.ok) {
                return response.json()
            }
            else {
                throw new Error(response.statusText)
            }
        }).then(function (json) {
            setGenders(JSON.parse(json))
            //setGenders((json))
        }).catch(function (err) {
            console.log('Fetch problem: ' + err.message)
            openAlert()
        }));
}

const FetchSalutations = async (setSalutations, openAlert) => {
    const uri = 'faex/boutique/getSalutations/'

    try {
        let response = await fetch(uri)
        if (response.ok) {
            let json = await response.json()
            console.log(json)
            await setSalutations(JSON.parse(json))
            console.log("FetchSalutations")
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}

const FetchOrderStates = async (setOrderStates, openAlert) => {
    const uri = 'faex/boutique/getOrderStates/'

    try {
        let response = await fetch(uri)
        if (response.ok) {
            let json = await response.json()
            console.log(json)
            await setOrderStates(JSON.parse(json))
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}

const FetchOrderProcessingStates = async (setOrderProcessingStates, openAlert) => {
    const uri = 'faex/boutique/getOrderProcessingStates/'

    try {
        let response = await fetch(uri)
        if (response.ok) {
            let json = await response.json()
            console.log(json)
            await setOrderProcessingStates(JSON.parse(json))
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}

const FetchDeliveryAgents = async (setDeliveryAgents, openAlert) => {
    const uri = 'faex/boutique/getDeliveryAgents/'

    try {
        let response = await fetch(uri)
        if (response.ok) {
            let json = await response.json()
            console.log(json)
            await setDeliveryAgents(JSON.parse(json))
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}



const FetchPaymentMethods = async (setPaymentMethods, openAlert) => {
    const uri = 'faex/boutique/getPaymentMethods/'

    try {
        let response = await fetch(uri)
        if (response.ok) {
            let json = await response.json()
            console.log(json)
            await setPaymentMethods(JSON.parse(json))
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}

const FetchSizeCategoriesTracked = async (setSizeCategories, openAlert) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    console.log(sessionSysId)
    //let sessionSysId = "7d675292-f344-4b9f-b02e-6b1f0dcfc054"
    const sizeCatUri = 'faex/articleTypes/getSizeCategories/{' + sessionSysId + '}'

    console.log(sizeCatUri)
    try {
        let response = await fetch(sizeCatUri)
        if (response.ok) {
            let json=  await response.json()
            setSizeCategories(JSON.parse(json))
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}
const FetchSizeCategories = (setSizeCategories, openAlert) => {
    trackPromise(FetchSizeCategoriesTracked(setSizeCategories, openAlert))
}


const FetchBoutiqueInfosTracked = async (setBoutiqueInfos, openAlert, setArticleDataToReady) => {
    let ownerSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    const uri = 'faex/boutique/getSaleDatas/{' + sessionSysId + '}/{' + ownerSysId + '}/{' + storageSysId + '}'

    try {
        let response = await fetch(uri)
        if (response.ok) {
            let json = await response.json()
            console.log(json)
            await setBoutiqueInfos(JSON.parse(json))
            setArticleDataToReady(true)
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}

const FetchBoutiqueInfos = (setBoutiqueInfos, openAlert, setArticleDataToReady, area) => {
    trackPromise(FetchBoutiqueInfosTracked(setBoutiqueInfos, openAlert, setArticleDataToReady), area)
}

const FetchBoutiqueInfosArticleTypesTracked = async (designerSysId, setArticleTypeInfos, openAlert, setArticleDataToReady) => {
    let ownerSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    console.log("FetchBoutiqueInfosArticleTypesTracked")
    const uri = 'faex/boutique/getArticleTypesForSale/{' + sessionSysId + '}/{' + ownerSysId + '}/{' + storageSysId + '}/{' + designerSysId + '}'

    try {
        let response = await fetch(uri)
        if (response.ok) {
            let json = await response.json()
            await setArticleTypeInfos(JSON.parse(json))
            setArticleDataToReady(true)
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}
const FetchBoutiqueInfosArticleTypes = (designerSysId, setArticleTypeInfos, openAlert, setArticleDataToReady, area) => {
    console.log("FetchBoutiqueInfosArticleTypes", designerSysId, setArticleTypeInfos, openAlert, setArticleDataToReady, area)
    trackPromise(FetchBoutiqueInfosArticleTypesTracked(designerSysId, setArticleTypeInfos, openAlert, setArticleDataToReady), area)
}

const FetchBoutiqueInfosArticleTypesForDeliveryTracked = async (designerSysId, setArticleTypeInfos, openAlert, setArticleDataToReady) => {
    let ownerSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    console.log("FetchBoutiqueInfosArticleTypesTracked")
    const uri = 'faex/boutique/getArticleTypesForDelivery/{' + sessionSysId + '}/{' + ownerSysId + '}/{' + storageSysId + '}/{' + designerSysId + '}'

    try {
        let response = await fetch(uri)
        if (response.ok) {
            let json = await response.json()
            await setArticleTypeInfos(JSON.parse(json))
            setArticleDataToReady(true)
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}
const FetchBoutiqueInfosArticleTypesForDelivery = (designerSysId, setArticleTypeInfos, openAlert, setArticleDataToReady, area) => {
    console.log("FetchBoutiqueInfosArticleTypes")
    trackPromise(FetchBoutiqueInfosArticleTypesForDeliveryTracked(designerSysId, setArticleTypeInfos, openAlert, setArticleDataToReady), area)
}

const FetchBoutiqueInfosArticleTypesForB2COrderTrack = async (designerSysId, setArticleTypeInfos, setSizeCategoryList, openAlert, setArticleDataToReady, signal, defaultAmount) => {
    let ownerSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    const uri = 'faex/boutique/getArticleTypesForB2COrder/{' + sessionSysId + '}/{' + ownerSysId + '}/{' + storageSysId + '}/{' + designerSysId + '}/{' + defaultAmount + '}'

    try {
        let response = await fetch(uri, signal)
        if (response.ok) {
            let json = await response.json()
            console.log("FetchBoutiqueInfosArticleTypesForB2COrderTrack", JSON.parse(json))
            let results = JSON.parse(json)
            await setArticleTypeInfos(results.ArticleTypes)
            setArticleDataToReady(true)
            await setSizeCategoryList(results.SizeCategories)
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}

const FetchBoutiqueInfosArticleTypesForB2COrder = (designerSysId, setArticleTypeInfos, setSizeCategoryList, openAlert, setArticleDataToReady, signal, area, defaultAmount) => {
    trackPromise(FetchBoutiqueInfosArticleTypesForB2COrderTrack(designerSysId, setArticleTypeInfos, setSizeCategoryList, openAlert, setArticleDataToReady, signal, defaultAmount), area)
}

const FetchBoutiqueTransactionsTracked = async (setTransactions, setFilteredTransactions, openAlert, setArticleDataToReady, signal, dailyReport) => {
    let ownerSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    const uri = 'faex/boutique/getSalesAndB2COrders/{' + sessionSysId + '}/{' + ownerSysId + '}/{' + storageSysId + '}/{' + dailyReport + '}'

    try {
        let response = await fetch(uri, { signal })
        if (response.ok) {
            let json = await response.json()
            console.log("Transactions:")
            console.log(json)
            await setTransactions(JSON.parse(json))
            await setFilteredTransactions(JSON.parse(json))
            setArticleDataToReady(true)
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        if (err && err.name !== "AbortError") openAlert()
    }
}
const FetchBoutiqueTransactions = (setTransactions, setFilteredTransactions, openAlert, setArticleDataToReady, signal, area, dailyReport = false) => {
    console.log("FetchBoutiqueTransactions ", setTransactions, setFilteredTransactions, openAlert, setArticleDataToReady, signal, area, dailyReport)
    trackPromise(FetchBoutiqueTransactionsTracked(setTransactions, setFilteredTransactions, openAlert, setArticleDataToReady, signal, dailyReport), area)
}

const FetchBoutiqueB2COrderTransactionsTracked = async (setTransactions, setFilteredTransactions, openAlert, setArticleDataToReady, signal) => {
    let ownerSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    const uri = 'faex/boutique/getB2COrders/{' + sessionSysId + '}/{' + ownerSysId + '}/{' + storageSysId + '}'

    try {
        let response = await fetch(uri, { signal })
        if (response.ok) {
            console.log("Transactions:")
            let json = await response.json()
            let parsedJson = JSON.parse(json)
            console.log("Transactions:", json, parsedJson)
            console.log(json, JSON.parse(json), setFilteredTransactions)
            await setTransactions(parsedJson)
            if (setFilteredTransactions !== null) await setFilteredTransactions(parsedJson)
            if (setArticleDataToReady !== null) setArticleDataToReady(true)
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}
const FetchBoutiqueB2COrderTransactions = (setTransactions, setFilteredTransactions, openAlert, setArticleDataToReady, signal, area) => {
    trackPromise(FetchBoutiqueB2COrderTransactionsTracked(setTransactions, setFilteredTransactions, openAlert, setArticleDataToReady, signal), area)
}

const FetchCreateBoutiqueTransactionTracked = async (transactionToCreate, reload, openAlert, handleClose, handleRedirect, setIsCreating) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    const uri = 'faex/boutique/createSale/{' + sessionSysId + '}/{' + storageSysId + '}'
    console.log(uri, transactionToCreate)
    setIsCreating(true)
    try {
        let response = await fetch(uri, {
            method: "POST",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(transactionToCreate),
        })
        if (response.ok) {
            reload()
            handleRedirect()
            handleClose()
            setIsCreating(false)
            return await response.json()
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}

const FetchCreateBoutiqueTransaction = (transactionToCreate, reload, openAlert, handleClose, handleRedirect, area, setIsCreating) => {
    trackPromise(FetchCreateBoutiqueTransactionTracked(transactionToCreate, reload, openAlert, handleClose, handleRedirect, setIsCreating), area)
}


const FetchCreateB2COrderTransaction = async (transactionToCreate, reload, openAlert) => {
    console.log("FetchCreateB2COrderTransaction ", sessionStorage.getItem("loginInformation"))
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    let userSysId = JSON.parse(sessionStorage.getItem("loginInformation")).UserSysId
    const uri = 'faex/boutique/createB2COrder/{' + sessionSysId + '}/{' + storageSysId + '}/{' + userSysId + '}'
    console.log(uri, JSON.stringify(transactionToCreate))
    try {
        let response = await fetch(uri, {
            method: "POST",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(transactionToCreate),
        })
        if (response.ok) {
            reload()
            return await response.json()
        }
        else {
            console.log(response)
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        console.log(err)
        openAlert()
    }
}

const FetchDeleteB2COrderTransaction = async (b2cOrderTransactionToDelete, openAlert, reload) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    console.log("FetchDeleteB2COrderTransaction11", b2cOrderTransactionToDelete)
    const deleteTransaction = 'faex/transactions/deleteB2COrderTransaction/{' + sessionSysId + '}/{' + storageSysId + '}/{' + b2cOrderTransactionToDelete + '}'
    try {
        let response = await fetch(deleteTransaction, {
            method: "DELETE",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
        })
        if (response.ok) {
            reload()
            return await response.json()
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}

const FetchBoutiquesTracked = async (setBoutiques, openAlert) => {
    let ownerSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    const uri = 'faex/boutique/getBoutiques/{' + sessionSysId + '}/{' + ownerSysId + '}/{' + storageSysId + '}'

    try {
        let response = await fetch(uri)
        if (response.ok) {
            let json = await response.json()
            setBoutiques(JSON.parse(json))
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}



const FetchBoutiques = (setBoutiques, openAlert, area) => {
    trackPromise(FetchBoutiquesTracked(setBoutiques, openAlert), area)
}

const FetchDesignersTracked = async (setDesigners, openAlert) => {
    let ownerSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    const uri = 'faex/boutique/getDesigners/{' + sessionSysId + '}/{' + ownerSysId + '}/{' + storageSysId + '}'

    try {
        let response = await fetch(uri)
        console.log('faex/boutique/getDesigners', response)

        if (response.ok) {
            let json = await response.json()
            setDesigners(JSON.parse(json))
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}
const FetchDesigners = (setDesigners, openAlert, area) => {
    trackPromise(FetchDesignersTracked(setDesigners, openAlert), area)
}

const FetchRegisterInventoryReportTracked = async (setOptions, openAlert, signal) => {
    let userSysId = JSON.parse(sessionStorage.getItem("loginInformation")).UserSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    let isFaex = JSON.parse(sessionStorage.getItem("loginInformation")).StorageType === "FAEX"
    const uri = 'faex/boutique/registerInventoryReport/{' + storageSysId + '}/{' + userSysId + '}/{' + isFaex + '}'

    try {
        let response = await fetch(uri, { signal })
        if (response.ok) {
            let json = await response.json()
            setOptions(JSON.parse(json))
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}
const FetchRegisterInventoryReport = (setOptions, openAlert, signal, area) => {
    trackPromise(FetchRegisterInventoryReportTracked(setOptions, openAlert, signal), area)
}

const FetchRegisterSalesReportTracked = async (setOptions, openAlert, signal) => {
    let userSysId = JSON.parse(sessionStorage.getItem("loginInformation")).UserSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    let isFaex = JSON.parse(sessionStorage.getItem("loginInformation")).StorageType === "FAEX"
    const uri = 'faex/boutique/registerSalesReport/{' + storageSysId + '}/{' + userSysId + '}/{' + isFaex + '}'

    try {
        let response = await fetch(uri, { signal })
        if (response.ok) {
            let json = await response.json()
            setOptions(JSON.parse(json))
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}
const FetchRegisterSalesReport = (setOptions, openAlert, signal, area) => {
    trackPromise(FetchRegisterSalesReportTracked(setOptions, openAlert, signal), area)
}

const FetchRegisterStocksReportTracked = async (setOptions, openAlert, signal) => {
    let userSysId = JSON.parse(sessionStorage.getItem("loginInformation")).UserSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    let isFaex = JSON.parse(sessionStorage.getItem("loginInformation")).StorageType === "FAEX"
    const uri = 'faex/boutique/registerStocksReport/{' + storageSysId + '}/{' + userSysId + '}/{' + isFaex + '}'

    try {
        let response = await fetch(uri, { signal })
        if (response.ok) {
            let json = await response.json()
            setOptions(JSON.parse(json))
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}
const FetchRegisterStocksReport = (setOptions, openAlert, signal, area) => {
    trackPromise(FetchRegisterStocksReportTracked(setOptions, openAlert, signal), area)
}

const FetchSalesReportFaexTracked = async (setReport, options, openAlert, signal) => {
    let userSysId = JSON.parse(sessionStorage.getItem("loginInformation")).UserSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    const uri = 'faex/boutique/getSalesReportFaex/{' + storageSysId + '}/{' + userSysId + '}'

    try {
        let response = await fetch(uri, {
            method: "PUT",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(options),
            signal: signal
        })
        if (response.ok) {
            let json = await response.json()
            setReport(JSON.parse(json))
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}
const FetchSalesReportFaex = (setReport, options, openAlert, signal, area) => {
    trackPromise(FetchSalesReportFaexTracked(setReport, options, openAlert, signal), area)
}

const FetchStocksReportTracked = async (setReport, options, openAlert, signal) => {
    let userSysId = JSON.parse(sessionStorage.getItem("loginInformation")).UserSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    const uri = 'faex/boutique/getStocksReport/{' + storageSysId + '}/{' + userSysId + '}'

    try {
        let response = await fetch(uri, {
            method: "PUT",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(options),
            signal: signal
        })
        if (response.ok) {
            let json = await response.json()
            setReport(JSON.parse(json))
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}
const FetchStocksReport = (setOrderDeliverty, options, openAlert, signal, area) => {
    trackPromise(FetchStocksReportTracked(setOrderDeliverty, options, openAlert, signal), area)
}

const FetchSelectedStocksReportTracked = async (setOrderDeliverty, options, openAlert, signal) => {
    let ownerSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    console.log("FetchSelectedStocksReportTracked", JSON.stringify(options))
    const uri = 'faex/stock/getSelectedArticleStockItems/{' + sessionSysId + '}/{' + ownerSysId + '}/{' + storageSysId + '}'
    console.log("FetchSelectedStocksReportTracked", JSON.stringify(options), uri)

    try {
        console.log('stock/getSelectedArticleStockItems', "before response")
        let response = await fetch(uri, {
            method: "PUT",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(options),
            signal: signal
        })
        console.log('stock/getSelectedArticleStockItems', "after response", response)

        if (response.ok) {
            let json = await response.json()
            setOrderDeliverty(JSON.parse(json))
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}
const FetchSelectedStocksReport = (setReport, options, openAlert, signal, area) => {
    trackPromise(FetchSelectedStocksReportTracked(setReport, options, openAlert, signal), area)
}

const FetchInventoryReportTracked = async (setInventory, options, openAlert, signal) => {
    let userSysId = JSON.parse(sessionStorage.getItem("loginInformation")).UserSysId
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let storageSysId = JSON.parse(sessionStorage.getItem("loginInformation")).StorageSysId
    console.log("FetchInventoryReportTracked", JSON.stringify(options))
    const uri = 'faex/stock/getInvetoryReportItems/{' + sessionSysId + '}/{' + userSysId + '}/{' + storageSysId + '}'
    console.log("FetchInventoryReportTracked", JSON.stringify(options), uri)

    try {
        console.log('stock/getSelectedArticleStockItems', "before response")
        let response = await fetch(uri, {
            method: "PUT",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(options),
            signal: signal
        })
        console.log('stock/getSelectedArticleStockItems', "after response", response)

        if (response.ok) {
            let json = await response.json()
            setInventory(JSON.parse(json))
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}
const FetchInventoryReport = (setReport, options, openAlert, signal, area) => {
    trackPromise(FetchInventoryReportTracked(setReport, options, openAlert, signal), area)
}

const FetchBillClearanceTracked = async (billClearance, openAlert, reload, signal) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    const uri = 'faex/boutique/createBillClearance/{' + sessionSysId + '}'

    try {
        let response = await fetch(uri, {
            method: "POST",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(billClearance),
            signal: signal
        })
        if (response.ok) {
            reload()
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}
const FetchBillClearance = (billClearance, openAlert, reload, signal, area) => {
    trackPromise(FetchBillClearanceTracked(billClearance, openAlert, reload, signal), area)
}

const FetchReadCustomersTracked = async (setCustomers, openAlert, signal, particularCostumers) => {
    let ownerSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let userSysId = JSON.parse(sessionStorage.getItem("loginInformation")).UserSysId
    const uri = 'faex/boutique/getCustomers/{' + sessionSysId + '}/{' + ownerSysId + '}/{' + userSysId + '}' 

    try {
        let response = await fetch(uri, { signal })
        if (response.ok) {
            let json = await response.json()
            setCustomers(JSON.parse(json))
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}
const FetchReadCustomers = (setCustomers, openAlert, signal, area, particularCustomers) => {
    trackPromise(FetchReadCustomersTracked(setCustomers, openAlert, signal, particularCustomers), area)
}

const FetchCreateCustomer = async(customerToCreate, setContactId, handleCloseModal, openAlert) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let ownerSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId
    let userSysId = JSON.parse(sessionStorage.getItem("loginInformation")).UserSysId
    const uri = 'faex/boutique/createCustomers/{' + sessionSysId + '}/{' + ownerSysId + '}/{' + userSysId + '}'
    try {
        let response = await fetch(uri, {
            method: "POST",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(customerToCreate),
        })
        if (response.ok) {
            handleCloseModal()
            let json = await response.json()
            if(setContactId !== null) await setContactId(JSON.parse(json))
        }
        else {
            console.log(response)
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        console.log(err)
        openAlert()
    }
}

const FetchUpdateCustomer = async (customerToUpdate, handleClose, openAlert, reload) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let ownerSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId
    let userSysId = JSON.parse(sessionStorage.getItem("loginInformation")).UserSysId
    const uri = 'faex/boutique/updateCustomers/{' + sessionSysId + '}/{' + ownerSysId + '}/{' + userSysId + '}'
    try {
        let response = await fetch(uri, {
            method: "PUT",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(customerToUpdate),
        })
        if (response.ok) {
            handleClose()
            if (reload !== null) {
                reload()
            }
            return await response.json()
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}

const FetchUpdateB2COrder = async (orderToUpdate, handleClose, openAlert, reload) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    let ownerSysId = JSON.parse(sessionStorage.getItem("loginInformation")).MandatorSysId
    let userSysId = JSON.parse(sessionStorage.getItem("loginInformation")).UserSysId
    const uri = 'faex/boutique/updateB2COrder/{' + sessionSysId + '}/{' + ownerSysId + '}/{' + userSysId + '}'
    try {
        let response = await fetch(uri, {
            method: "PUT",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(orderToUpdate),
        })
        if (response.ok) {
            handleClose()
            if (reload !== null) {
                reload()
            }
            return await response.json()
        }
        else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}

const FetchReadServerVersion = async (setServerVersion) => {
    const uri = 'faex/getServerVersion/'

    try {
        let response = await fetch(uri)
        if (response.ok) {
            let json = await response.json()
            setServerVersion(JSON.parse(json))
            return json
        } else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
    }
}

const FetchDoDataOvertakeTracked = async (openAlert, signal) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    const uri = 'faex/doDataOvertake/{' + sessionSysId + '}'

    try {
        let response = await fetch(uri, {
            method: "PUT",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            signal: signal
        })
        if (response.ok) {
            let json = await response.json()
            let message = JSON.parse(json).Message
            console.log("FetchDoDataOvertakeTracked", json, signal)
            if (message != null && message.Text !== "")
                throw new Error(message)
        }
        else {
            throw new Error(response.statusText.Text)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}
const FetchDoDataOvertake = (openAlert, signal, area) => {
    trackPromise(FetchDoDataOvertakeTracked(openAlert, signal), area)
}

const FetchDoSQLDumpTracked = async (openAlert, signal) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    const uri = 'faex/doSQLDump/{' + sessionSysId + '}'

    try {
        let response = await fetch(uri, {
            method: "PUT",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            signal: signal
        })
        if (response.ok) {
            let json = await response.json()
            let message = JSON.parse(json).Message
            console.log("FetchDoDataOvertakeTracked", json, signal)
            if (message != null && message.Text !== "")
                throw new Error(message)
        }
        else {
            throw new Error(response.statusText.Text)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}
const FetchDoSQLDump = (openAlert, signal, area) => {
    trackPromise(FetchDoSQLDumpTracked(openAlert, signal), area)
}

const FetchDoPictureOvertakeTracked = async (openAlert, signal) => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    const uri = 'faex/doPictureOvertake/{' + sessionSysId + '}'

    try {
        let response = await fetch(uri, {
            method: "PUT",
            //mode: "no-cors",
            headers: {
                'Accept': '*',
                'Content-Type': 'application/json; charset=utf-8',
            },
            signal: signal
        })
        if (response.ok) {
            let json = await response.json()
            let message = JSON.parse(json).Message
            console.log("FetchDoPictureOvertakeTracked", json, signal)
            if (message != null && message.Text !== "")
                throw new Error(message)
        }
        else {
            throw new Error(response.statusText.Text)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
        openAlert()
    }
}
const FetchDoPictureOvertake = (openAlert, signal, area) => {
    trackPromise(FetchDoPictureOvertakeTracked(openAlert, signal), area)
}

const FetchBackendPingToPreventTimeout = async () => {
    let sessionSysId = JSON.parse(sessionStorage.getItem("loginInformation")).SessionSysId
    const uri = 'faex/keepConnection/{' + sessionSysId + '}'

    try {
        let response = await fetch(uri)
        if (response.ok) {
            let json = await response.json()
            return json
        } else {
            throw new Error(response.statusText)
        }
    } catch (err) {
        console.log('Fetch problem: ' + err.message)
    }
}

export {
    FetchCreateArticle, FetchArticleTypes, FetchUpdateArticle,
    FetchTransactionInfos, FetchCreateTransaction,
    FetchReadIncomingTransactions, FetchReadOutgoingTransactions, FetchApproveCorrection,
    FetchInventory, FetchLocalizedAnalysis,
    FetchLogin,
    FetchGenders, FetchSalutations, FetchSizeCategories, FetchOrderStates, FetchOrderProcessingStates, FetchDeliveryAgents, FetchPaymentMethods, 
    FetchArticleTypeImages,
    FetchBoutiqueInfos, FetchBoutiqueTransactions, FetchBoutiqueB2COrderTransactions, FetchCreateBoutiqueTransaction, FetchCreateB2COrderTransaction, FetchBoutiques, FetchBoutiqueInfosArticleTypes, FetchBoutiqueInfosArticleTypesForDelivery, FetchBoutiqueInfosArticleTypesForB2COrder, FetchCreatePartialInventoryTransactionDraft, FetchCreateStartFullInventoryTransaction, FetchStartedFullInventoryTransaction, FetchCreateInventoryTransaction,
    FetchDesigners,
    FetchCreateTransactionDraft, FetchUpdateTransactionDraft, FetchDeleteTransactionDraft, FetchDeleteSaleTransaction, FetchDeleteB2COrderTransaction,
    FetchRegisterSalesReport, FetchRegisterStocksReport, FetchRegisterInventoryReport,
    FetchSalesReportFaex, FetchStocksReport, FetchSelectedStocksReport, FetchInventoryReport,
    FetchBackendPingToPreventTimeout,
    FetchBillClearance,
    FetchReadCustomers, FetchCreateCustomer, FetchUpdateCustomer,
    FetchUpdateB2COrder,
    FetchReadServerVersion,
    FetchDoDataOvertake, FetchDoSQLDump, FetchDoPictureOvertake
    //FetchDummyTest
}